import React from "react"
import { HEADER_HEIGHT, NAVBAR } from "../Private/PrivatePage"
import { Grid, useMediaQuery } from "@mui/material"
import { MobileSidebar, Sidebar } from "../../navigation/routing/Sidebar"
import { theme } from "../../../../pages/private/DataTableComponent"
import PrivateHeader from "../Private/PrivateHeader"
import ChartBlock from "../../ChartBlock"
import { AddNewArticle } from "./AddArticleForm"

export const AddArticlePage = () => {

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const contentWidth = isMobile ? '100%' : `calc(88vw - ${NAVBAR}vw)`
    const marginLeft = isMobile ? 0 : `14vw`

    return (
        <Grid height="auto">
            <Grid item>{isMobile ? <MobileSidebar /> : <Sidebar />}</Grid>
            <Grid item sx={{ width: contentWidth, marginLeft: marginLeft }}>
                <PrivateHeader
                    title={""}
                />
                <Grid item sx={{ height: `calc(100% - ${HEADER_HEIGHT}vh)`, p: "1vh" }}>
                    <ChartBlock title="Ajouter un nouvel article en base de données" >
                        <Grid item sx={{ height: "auto", p: "1vw" }}>
                            <AddNewArticle />
                        </Grid>
                    </ChartBlock>
                </Grid>
            </Grid>
        </Grid >
    )
}

